import type { Photo, TimedPhoto } from '@/types'

/**
 * The site's own photography, served from the project CDN.
 * The times and dates are when each of the three venue photos was taken,
 * read from the original upload file names.
 */
const CDN = 'https://unity-space-berlin.cdn.modulify.website/images'

export const morningLoft: TimedPhoto = {
    src: `${CDN}/20260319_0751171-scaled.jpg`,
    width: 2560,
    height: 1183,
    alt: "The Unity Space loft in morning light: raw brick walls, tall factory windows, a palm tree and soft floor seating around a small altar",
    time: '07:51',
    date: '19.03.2026'
}

export const nightPanorama: TimedPhoto = {
    src: `${CDN}/20260328_004841-scaled.jpg`,
    width: 2560,
    height: 1006,
    alt: "Panorama of the loft after dark, glowing in amber and violet light, with floor cushions, candles and the palm tree",
    time: '00:48',
    date: '28.03.2026'
}

export const berlinSkyline: TimedPhoto = {
    src: `${CDN}/20240709_212205-scaled.jpg`,
    width: 2560,
    height: 1024,
    alt: "Sunset over the Berlin skyline with the TV tower and the dome of the Französischer Dom",
    time: '21:22',
    date: '09.07.2024'
}

export const circlePhoto: Photo = {
    src: `${CDN}/header-Circle-2-1-scaled.jpg`,
    width: 2560,
    height: 1428,
    alt: "A group of people standing close together in a circle, arms around each other"
}

export const handsPhoto: Photo = {
    src: `${CDN}/Header6_Hands-1.png`,
    width: 2600,
    height: 1450,
    alt: "Two hands gently clasped together"
}

export const laughterPhoto: Photo = {
    src: `${CDN}/header5_Group-1-1.png`,
    width: 2600,
    height: 1450,
    alt: "Participants laughing and raising their hands during a session"
}

export const hugPhoto: Photo = {
    src: `${CDN}/header4_hug-1.png`,
    width: 2600,
    height: 1450,
    alt: "Two people sharing a warm hug"
}

export const cacaoPhoto: Photo = {
    src: `${CDN}/header3_Cacao-1.png`,
    width: 2600,
    height: 1450,
    alt: "Preparing a ceremony: a lotus candle, palo santo, warm candles and a pot of cacao"
}

export const peachesPhoto: Photo = {
    src: `${CDN}/organic-farming-03.jpg`,
    width: 960,
    height: 1140,
    alt: "Ripe peaches piled together"
}

/** Images that drift beside the cursor when hovering the programme. */
export const programmePreviews: Array<Photo> = [
    laughterPhoto,
    cacaoPhoto,
    circlePhoto,
    hugPhoto,
    handsPhoto,
    morningLoft
]
